import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss']
})
export class CustomerDetailsComponent implements OnInit {

  /* Vars */
  pageType: string = 'customer360';
  srvcId = "#SR0023889";
  percentCompleted = 60; // Servicing

  constructor(
    private message: NzMessageService,
    private modalService: NzModalService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    /* Set 'from' */
    this.route.snapshot.paramMap.get('from')?this.pageType=this.route.snapshot.paramMap.get('from'):null;
  }

  ngOnInit() {
  }

  /* Freeze */
  caseIsFrozen: boolean = false;
  productTypeConfig
  workflowPanel
  corresPanel
  notesPanel
  docuPanel
  worksheetPanel
  analyticsModal
  freezeToggle() {
    /* Message */
    if(this.caseIsFrozen) this.message.loading('Unfreezing case ...', { nzDuration: 1200 });
    else this.message.loading('Freezing case', { nzDuration: 1200 });
    /* Toggle */
    this.caseIsFrozen = !this.caseIsFrozen;
    /* Set vars */
    if(this.caseIsFrozen) {
    }
    else {

    }
  }
  /* Star */
  isStarred:boolean = false;
  /* Demo case --- only "adding" is shown */
  starThis() {
    this.message.loading('Adding to starred items', { nzDuration: 1200 });
    setTimeout(()=>{
      this.message.success(this.srvcId + ' added to you starred items', { nzDuration: 1200 });
      this.isStarred = true;
    }, 1200);
  }

  /* Video / Call Modals */
  modalUsrCall = false;
  modalUsrCallVideo = false;
  videoCallOngoing = false;
  videoCall(val) {
    this.videoCallOngoing = !!val;
  }


  /* PANELS */
  policyPanelOpen = false;
  policyPanel(status){ this.policyPanelOpen = !!status }
  profilePanelOpen = false;
  profilePanel(status){ this.profilePanelOpen = !!status }


  /* Modal for SR */
  srModal:boolean = false;
  srType = 'address';
  serviceRequestModal(type){
    this.srModal = false;
    this.srType = type;
    setTimeout(()=>{
      this.srModal = true;
    }, 100);
  }

}
